import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CreateWebsiteMode} from "../../models/create-website-option.model";
import {TextUtils} from "../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-create-website-options',
    templateUrl: './create-website-options.component.html',
    styleUrls: ['./create-website-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CreateWebsiteOptionsComponent implements OnInit {

  @Input() selectedMode: CreateWebsiteMode = 'single';
  @Input() hasWebsite = false;
  @Input() canCreateMultisite = false;
  @Output() modeSelected = new EventEmitter<CreateWebsiteMode>();
  public options = [
      {mode: 'single', slug: TextUtils.getText('text_singleWpWebsite')},
  ];

  constructor() { }

  ngOnInit() {
    if (this.canCreateMultisite) {
      this.options.push({mode: 'multisite', slug: TextUtils.getText('text_multisite')});
    }
    if (this.hasWebsite) {
      this.options.push({mode: 'clone', slug: TextUtils.getText('text_cloneWebsite')});
    }
  }

}
